<template>
  <container-data-input-card
    :value="orgData"
    :config="config"
    :blocked="block"
    is-single
    can-close-enter
    :spr-data="sprList"
    :saving="loading"
    :error="error"
    :appealStatus="appealStatus"
    @change-data="sendAppeal($event)"
  >
  </container-data-input-card>
</template>

<script>
import ContainerDataInputCard from "@/components/cards/DataCardInput/ContainerDataInputCard";
import mainOrg from "@/pages/Contacts/configs/mainOrg";
import {mapGetters} from "vuex";
import AppealOrganizationController from "@/controllers/Organizations/AppealOrganizationController";

export default {
  name: "OrgMainContainer",
  components: {ContainerDataInputCard},
  data() {
    return {
      orgData: {},
      saving: false,
      error: null,
      config: mainOrg,
      appeal: {
        appealType: 'MAIN_ORG'
      }
    }
  },
  props: {
    appealStatus: {
      type: Boolean || null,
      default: true
    }
  },
  computed: {
    block() {
      return false
    },
    loading() {
      return this.getTypesStatus || this.getFoundersStatus || this.get_org_appeals_loading || this.saving
    },
    ...mapGetters('spr', {
      getMainOrg: 'getMainOrg',
      getAvailableOrgsStatus: 'getAvailableOrgsStatus',
      getFounders: 'getFounders',
      getFoundersStatus: 'getFoundersStatus',
      getTypes: 'getTypes',
      getTypesStatus: 'getTypesStatus',
    }),
    ...mapGetters('appeals', {
      get_org_appeals_data: 'get_org_appeals_data',
      get_org_appeals_loading: 'get_org_appeals_loading',
      get_org_appeals_error: 'get_org_appeals_error',
    }),
    sprList() {
      return {
        orgTypes: {data: this.getTypes.map(el => ({value: el.id, text: el.name})), loading: this.getTypesStatus},
        founders: {data: this.getFounders.map(el => ({value: el.id, text: el.name})), loading: this.getFoundersStatus}
      }
    }
  },
  created() {
    if (!this.getAvailableOrgsStatus)
      this.initData()
  },
  watch: {
    getMainOrg() {
      this.initData()
    },
    get_org_appeals_loading() {
      this.initAppeal();
      this.initData();
    }
  },
  methods: {
    initData() {
      if (this.getMainOrg) {
        this.initAppeal();
        this.orgData = {
          name: this.appeal.name ?? this.getMainOrg?.name,
          type: this.appeal?.orgType?.id ?? this.getMainOrg?.type?.id,
          nameFull: this.appeal.nameFull ?? this.getMainOrg?.nameFull,
          nameShort: this.appeal.nameShort ?? this.getMainOrg?.nameShort,
          address: this.appeal.address ?? this.getMainOrg?.address,
          inn: this.appeal.inn ?? this.getMainOrg?.inn,
          kpp: this.appeal.kpp ?? this.getMainOrg?.kpp,
          founderName: this.appeal.founderName ?? this.getMainOrg?.founderName,
          org: {id: this.getMainOrg?.id},
          owner: {id: this.getMainOrg?.ownerId},
          founder: {id: this.getMainOrg?.founder?.id},
          appealType: 'MAIN_ORG'
        };
        this.saving = false;
        this.error = null;
      }
    },
    initAppeal() {
      const x = this.get_org_appeals_data.data.filter(el => el.appealType === 'MAIN_ORG');
      const appeal = x[x.length - 1]; // последняя из апелляций по MAIN_ORG
      if (appeal?.accept === null) {
        this.appeal = {...appeal, ...this.appeal};
        this.$emit('update-appeal', this.appeal.accept)
      }
    },
    sendAppeal(payload) {
      this.saving = true;
      AppealOrganizationController.setAppeal(payload).then(data => {
        this.appeal = data;
        this.initAppeal();
      }).catch(() => this.error = 'Ошибка отправления').finally(() => this.saving = false)
    }
  },
}
</script>

<style scoped>

</style>